import React, { useState, useContext, Dispatch } from "react";
import { toast } from "react-toastify";
import ProjectContext from "../../../contexts/ProjectContext";
import { RolesContext } from "../../../contexts/RolesContext";
import { useOffline } from "../../../contexts/OfflineContext";
import AddContactModal from "../../Contacts/AddContactModal";
import projectApi from "../../../utils/api/project";

export interface IContactAddProps {
  currentContactIds: Array<number>;
  onAdd: Dispatch<any>;
}

const ContactAdd: React.FC<IContactAddProps> = ({
  currentContactIds,
  onAdd,
}) => {
  const context = useContext(ProjectContext);
  const permCheck = useContext(RolesContext).userHasPermission;
  const offline = useOffline();
  const canInvite =
    !offline && permCheck('create', 'Users') && permCheck('update', 'Project');
  const [show, setShow] = useState<boolean>(false);
  const hideModal = () => setShow(false);
  const showModal = () => setShow(true);
  const id = context.project ? context.project.id : null;

  return id ? (
    <React.Fragment>
      <button className="outline small" onClick={showModal}>
        <React.Fragment>
          <i className="fa fa-plus pad-right" /> Add Contact
        </React.Fragment>
      </button>

      <AddContactModal
        show={show}
        hideModal={hideModal}
        currentContactIds={currentContactIds}
        handleAdd={userIds =>
          projectApi.contacts.create(id, userIds).then(onAdd)
        }
        handleInvite={canInvite ? (emails, roleId) =>
          projectApi.contacts.invite(id, emails, roleId).then(results => {
            results.forEach(({ email, status }) =>
              toast.success(
                status === 'invited'
                  ? `Invited ${email}`
                  : status === 'added'
                    ? `${email} already has an account; added as a contact with their current role`
                    : `${email} was already in the division and has been added to the project successfully`,
              ),
            );
          }).finally(() => onAdd(null)) : undefined
        }
        clientName={context.project?.client?.name}
      />
    </React.Fragment>
  ) : null;
};

export default ContactAdd;
